import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

const MyRefundsTab = (props: { intl: IntlShape }) => {
  return <div />;
};
const mapStateToProps = createStructuredSelector<any, {}>({});

const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MyRefundsTab));
